import React from "react";

import {Configuration} from "./generated/configuration";
import {APIV6Api} from "./generated/api";

import axios from 'axios';
import {serverUrl} from "./Serveur";

const config = new Configuration();
const axiosInstance = axios.create({});

const apiDpeCtrlApi = new APIV6Api(config, serverUrl, axiosInstance);

export default class DpeCtrl extends React.Component {




    static async getStatsIris(codeIris, callback) {
        apiDpeCtrlApi.v6StatsGet(codeIris).then((result) => {
            callback(result.data);
        })
    }

    static async getShape(codeIris, callback) {
        apiDpeCtrlApi.v6ShapeGet(codeIris).then((result) => {
            callback(result.data);
        })
    }
    static async getShapeInsee(codeIris, callback) {
        apiDpeCtrlApi.v6CodeinseeShapeGet(codeIris).then((result) => {
            callback(result.data);
        })
    }

    static async gestListOfDpes(codeIris, callback) {
        apiDpeCtrlApi.v6Dpve2Get(codeIris).then((result) => {
            callback(result.data);
        })
    }


    static async gestListOfDpesTer(codeIris, callback) {
        apiDpeCtrlApi.v6DpvTerGet(codeIris).then((result) => {
            callback(result.data);
        })
    }

    static async gestListOfDpesTerInsee(codeIris, callback) {
        apiDpeCtrlApi.v6CodeinseeDpvTerGet(codeIris).then((result) => {
            callback(result.data);
        })

    }

    static async gestListOfDpesByInsee(codeIris, callback) {
        apiDpeCtrlApi.v6CodeinseeDpve2Get(codeIris).then((result) => {
            callback(result.data);
        })
    }




}
